import React from 'react';
import styled, { css } from 'styled-components';
import CallToActionBlock, {
  CTAIcon,
  IconSize,
} from '~/components/CallToActionBlock';
import { NotificationLevel } from '~/graphql/types';

type Props = {
  cta?: {
    label: string;
    onClick: () => void;
  };
  level: NotificationLevel;
  header?: string;
  htmlBody: string;
  onClose: () => void;
  key: string;
};

const getIconForWarning = (level: NotificationLevel): CTAIcon => {
  const size: IconSize = 'base';
  switch (level) {
    case NotificationLevel.Error:
      return { name: 'error', background: 'danger', size };
    case NotificationLevel.Warning:
      return { name: 'triangle', background: 'warning', size };
    case NotificationLevel.Info:
    default:
      return { name: 'info', background: 'info', size };
  }
};

const WarningCTA: React.FC<Props> = ({
  cta,
  level,
  header,
  htmlBody,
  onClose,
  key,
}) => {
  const icon = getIconForWarning(level);

  return (
    <StyledCTABlock
      button={
        cta
          ? {
              icon: 'arrowRight',
              label: cta.label,
              appearance: 'secondary',
              onClick: cta.onClick,
            }
          : undefined
      }
      header={header}
      onClose={onClose}
      align="center"
      padding={['base', 'm']}
      icon={icon}
    >
      <div
        key={key}
        dangerouslySetInnerHTML={{
          __html: htmlBody,
        }}
      />
    </StyledCTABlock>
  );
};

const StyledCTABlock = styled(CallToActionBlock)(
  ({ theme }) => css`
    width: 100%;
    a {
      color: ${theme.color('white')};
    }
  `,
);

export default WarningCTA;
